<template>
  <div class='row page-section'>
    <div class='large-12 columns'>
      <div v-if='hasData && !showError' class='block block-main block-live-main'>
        <top-image-box v-if='showImageBox'></top-image-box>
        <top-text-box></top-text-box>
      </div>
      <div v-else class='block block-main'>
          <div class="block-main-media">
            <img :src='errorImage' alt="Image" />
          </div>
          <div class="block-main-content block-main-content-alert center ">
          <div>
            <h2 class="block-main-title">{{errorTitle}}</h2>
            <p class="block-main-excerpt" v-html='errorText'>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopImageBox from './TopImageBox'
  import TopTextBox from './TopTextBox'

  export default {
    name: 'top',
    components: {
      TopImageBox,
      TopTextBox
    },
    data () {
      return {
        hasData: !this.$root.errorNoData,
        showError: this.$root.cmsData.mainBlock.hearingErrorTop,
        showImageBox: this.$root.cmsData.mainBlock.hasImage,
        errorTitle: this.$root.cmsData.mainBlock.hearingsUnavailableTitle,
        errorText: this.$root.cmsData.mainBlock.hearingsUnavailableMessage,
        errorImage: this.$root.cmsData.mainBlock.hearingsUnavailableImage
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Top.vue?5ea0c15f